/**
 * @module constants/Volume
 */

export const VolumeActions = Object.freeze({
  SET_VOLUME: 'VOLUME_SET_VOLUME',
  SET_MUTED: 'VOLUME_SET_MUTED',
} as const);

export * from '../domains/playback/audio/volume/constants';
